import React, { useState, useCallback, useMemo } from 'react'
import { Row, Column } from '@/components/layout/layout'
import { Goods } from '@/model/types/goods'
import { Popover } from 'antd'
import './loss-unit-popover.scss'
import classnames from 'classnames'
import useBemClass from '@/utils/hooks/useBEMClass'

export interface ILossUnit {
    sale_unit_ratio: number | string
    name: string
    id: number
    key: number
}

interface LossUnitPopoverProps {
    onConfirm: (unit: ILossUnit | null) => void
    goods: Goods
    unit: ILossUnit | null
}

const LossUnitPopover: React.FC<LossUnitPopoverProps> = props => {
    const cls = useBemClass('loss-unit-popover')
    const [visable, setVisable] = useState<boolean>(false)
    const [unit, setUnit] = useState<ILossUnit | null>(props.unit)

    const goodUnit = useMemo(() => {
        if (props.goods.pricing_methods.length > 1) {
            return props.goods.pricing_methods.map((price, index) => {
                return {
                    ...price.sales_unit,
                    key: index,
                    sale_unit_ratio: price.sales_unit_ratio,
                }
            })
        } else {
            return []
        }
    }, [props.goods])

    const hidden = useCallback(() => {
        setVisable(false)
    }, [])

    return (
        <Popover
            placement="topRight"
            arrowPointAtCenter
            trigger="click"
            visible={visable}
            onVisibleChange={visible => {
                setVisable(visible)
            }}
            content={
                <Column className={cls()}>
                    <Row>
                        <div className={cls('title')}>报损单位</div>
                        {unit && (
                            <div className={cls('des')}>
                                (计价单位: 1{unit.name}={unit.sale_unit_ratio}
                                {props.goods.stock_unit.name})
                            </div>
                        )}
                    </Row>
                    <Row data-align-items-center data-margin-top-10>
                        {goodUnit.map(units => {
                            return (
                                <div
                                    key={units.key}
                                    className={classnames(cls('unit'), {
                                        [`${cls('unit-check')}`]: unit && unit.id === units.id,
                                    })}
                                    onClick={() => {
                                        setUnit(units)
                                    }}
                                >
                                    {units.name}
                                </div>
                            )
                        })}
                    </Row>
                    <Row data-align-items-center data-margin-top-10 data-justify-content-flex-end data-width-100p>
                        <div
                            className={cls('btn')}
                            onClick={() => {
                                // @ts-ignore
                                props.onConfirm(unit)
                                hidden()
                            }}
                        >
                            确定
                        </div>
                    </Row>
                </Column>
            }
        >
            {props.children}
        </Popover>
    )
}

export default LossUnitPopover
